import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const NoPermissionPage = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="60vh"
      bgcolor="#f9f9f9"
      textAlign="center"
      px={2}
    >
      <LockIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h4" gutterBottom color="textPrimary">
        You don't have access to this
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={4}>
        You do not have the necessary permissions to access this page.
      </Typography>
      {/* <Button variant="contained" color="primary" onClick={() => window.history.back()}>
        Go Back
      </Button> */}
    </Box>
  );
};

export default NoPermissionPage;
